import styled, { css } from 'styled-components/macro'
import { Button } from '../../commons/Button'
import Icon from '../../commons/Icon'
import Container from '../../components/Container'

export const ChangePasswordIcon = styled(Icon)``

export const ChangePassword = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.default};
  height: 100vh;

  @media ${({ theme }) => theme.screens.md} {
    background-image: unset;
    min-height: 100vh;
  }
`

export const ChangePasswordImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ backgroundImage }) => backgroundImage?.includes('assets') ? '100vh' : '90%'};
  width: 100%;
  max-width: 100%;

  @media ${({ theme }) => theme.screens.md} {
    background-image: unset;
    min-height: 0%;
    width: 0%;
  }
`

export const ChangePasswordImage = styled.img`
  max-width: 60%;

  @media ${({ theme }) => theme.screens.md} {
    background-image: unset;
    min-height: 0%;
    width: 0%;
  }
`

export const ChangePasswordContainer = styled(Container)`
  height: 100%;
`

export const ChangePasswordWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 4rem;
  margin-right: 5%;

  @media ${({ theme }) => theme.screens.md} {
    padding-top: 6rem;
    align-items: unset;
    justify-content: unset;
    gap: 0;
    margin-right: 0;
  }
`

export const ChangePasswordInner = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 52rem;
  width: 100%;

  @media ${({ theme }) => theme.screens.md} {
    max-width: unset;
  }
`

export const ChangePasswordLogo = styled.img`
  max-width: 100%;
  max-height: 12rem;
`

export const ChangePasswordLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
  background: ${({ theme }) => theme.colors.mono.white};
  border-radius: .8rem;
  @media ${({ theme }) => theme.screens.md} {
    width: 16rem;
  }
`

export const ChangePasswordTitle = styled.h1`
  max-width: 36.7rem;
  width: 100%;
  margin-top: 3rem;
  font-size: 3.2rem;
  line-height: 3.8rem;
  text-align: center;
  letter-spacing: -0.1rem;
  color: ${({ theme }) => theme.colors.mono.white};

  @media ${({ theme }) => theme.screens.lg} {
    font-size: 2.4rem;
    line-height: 2.8rem;
  }
`

export const ChangePasswordText = styled.p`
  margin-top: 1.5rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: ${({ theme }) => theme.colors.mono.white};
`

export const ChangePasswordBox = styled.div`
  width: 100%;
  margin-top: 3rem;
  padding: 6rem;
  background: ${({ theme }) => theme.colors.mono.white};
  border-radius: .8rem;

  @media ${({ theme }) => theme.screens.lg} {
    padding: 3rem;
  }
`

export const ChangePasswordBoxTitle = styled.h3`
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.2rem;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const ChangePasswordBoxText = styled.p`
  margin-bottom: 3rem;
  font-size: 1.3rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
`

export const HomeField = styled.div`
  position: relative;
  margin-bottom: 3rem;
`

export const HomeFieldLabel = styled.span`
  position: absolute;
  left: 0;
  bottom: 2rem;
  transition: all .2s ease;
  display: block;
  font-size: 1.3rem;
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  pointer-events: none;
`

export const HomeFieldInput = styled.input`
  width: 100%;
  padding: 2.9rem 0 1.4rem;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.mono.greyDark};

  &:not(:placeholder-shown) + ${HomeFieldLabel},
  &:focus + ${HomeFieldLabel} {
    color: ${({ theme }) => theme.colors.primary.default};
    bottom: 4.6rem;
  }

  &:focus {
    outline: 0;
  }
`

export const ChangePasswordFieldInputPasswordButton = styled.button`${({ isActive }) => css`
  position: absolute;
  right: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.dark};
  }

  ${isActive && css`
    color: ${({ theme }) => theme.colors.mono.greyDark};
  `}
`}`

export const HomeFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const HomeFieldButton = styled.button`
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.mono.black};
  }
`

export const ChangePasswordButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
  padding: 0;
  height: 5rem;
  background-color: ${({ theme }) => theme.colors.blue.default};;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue.dark};;
  }
`
